import {getPrivateAxios} from '../../libs';
import {UserLastSeenEvent} from '../user-events';

export interface TeamMembers {
  role?: 'owner' | 'member';
  createdAt: string;
  userId?: string;
  teamId?: string;
  code?: string;
  user: {
    fullName?: string;
    email: string;
    events?: UserLastSeenEvent[];
  };
}

export const fetchTeamMembers = async (teamId: string) => {
  return getPrivateAxios()
    .get<TeamMembers[]>(`/teams/${teamId}/members`)
    .then((r) => r.data);
};
